import Vue from "vue";
import FunctionalCalendar from "vue-functional-calendar";
Vue.use(FunctionalCalendar);
